(function ($, window, document) {
    var $win    = $(window);
    var $doc    = $(document);
    var $header = $('.js-header');
    var $body   = $('body');
    var $root   = $('html');
    var $main   = $('main');
    var $modals = $('.modal');

    function window_width() {
        var myWidth = 0;
        if (typeof window.innerWidth == "number") myWidth = window.innerWidth;
        else if (document.documentElement && document.documentElement.clientWidth)
            myWidth = document.documentElement.clientWidth;
        else if (document.body && document.body.clientWidth)
            myWidth = document.body.clientWidth;
        return myWidth;
    }

    function window_height() {
        var myHeight = 0;
        if (typeof window.innerHeight == "number") myHeight = window.innerHeight;
        else if (document.documentElement && document.documentElement.clientHeight)
            myHeight = document.documentElement.clientHeight;
        else if (document.body && document.body.clientHeight)
            myHeight = document.body.clientHeight;
        return myHeight;
    }

    function is_desktop() {
        return window_width() > 1023;
    }

    function is_tablet() {
        return window_width() <= 1023 && window_width() > 767;
    }

    function is_mobile() {
        return window_width() <= 767;
    }

	/*
		Sliders
	 */

    $('.js-slider .slider__slides').each(function () {
        let $this = $(this);
        let play_speed = $this.data('speed');

        let settings = {
            prevArrow: `<a href="#" class="slider__arrow slider__prev">
                <span>&larr;</span>
            </a>`,
            nextArrow: `<a href="#" class="slider__arrow slider__next">
                <span>&rarr;</span>
            </a>`,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        arrows: false,
                        dots: true,
                    }
                }
            ],
        };

        if ( play_speed !== undefined ) {
            settings['autoplay'] = true;
            settings['autoplaySpeed'] = play_speed;
        }

        // if ($this.closest('.slider').hasClass('slider--testimonials')) {
        //     settings['fade'] = true;
        // }

        // Position arrows and dots to bottom of img for .slider--media (full-width-media module).
        $this.on('setPosition', function({target}) {
            let $slider = $(target);

            if ( $slider.closest('.slider--media').length ) {
                let $arrows = $this.find('.slider__arrow');
                let $dots   = $this.find('.slick-dots');

                if ( ! $arrows.length && ! $dots.length ) {
                    return;
                }

                let media_height = $slider.find('.slick-current .media').innerHeight();

                $arrows.css({
                    'top': media_height - 85,
                    'bottom': 'auto',
                });

                $dots.css({
                    'top': media_height - 22,
                    'bottom': 'auto',
                });
            }
        })

        $this.on('init', function(e, slick) {
            $( slick.$slides[ slick.currentSlide ] ).addClass('slick-finished');
        });

        $this.on('afterChange', function(e, slick, currentSlide) {
            slick.$slides.removeClass('slick-finished');
            $( slick.$slides[ currentSlide ] ).addClass('slick-finished');
        });

        $this.slick( settings );
    });

    $('.js-slider-articles .slider__slides').each(function () {
        var $this = $(this);
        var initFlag = false;

        var settings = {
            prevArrow: `<a href="#" class="slider__arrow slider__prev">
                <span>&larr;</span>
            </a>`,
            nextArrow: `<a href="#" class="slider__arrow slider__next">
                <span>&rarr;</span>
            </a>`,
            responsive: [
                {
                    breakpoint: 6200,
                    settings: 'unslick',
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll:1,
                        arrows: false,
                        dots: true,
                    },
                },
            ]
        };

        $this.slick(settings);

        $this.on('init', function (argument) {
            initFlag = true;
        });

        $this.on('destroy', function (argument) {
            initFlag = false;
        });

        $win.on('load resize', function () {
            if($win.width() > 767) {
                $this.slick('unslick');
            }

            if($win.width() < 767 && !initFlag) {
                $this.not('.slick-initialized').slick(settings);
            }
        });
    });

    /*
        Main Padding
        */

    $win.on('load resize', function () {
        $body.css('--main-padding-top', `${$header.outerHeight()}px`);
    });

    /*
        Header Scroll
        */

    var prevTop = $win.scrollTop();

    $win.on('scroll load', function () {
        var currentTop = $win.scrollTop();
        if(currentTop > prevTop && ! $header.hasClass('is-active') ) {
            $header.addClass('is-hidden');
        } else {
            $header.removeClass('is-hidden');
        }

        if( currentTop < $header.height()) {
            $header.removeClass('is-hidden');
        }

        prevTop = currentTop;
    });

    /*
        Hero Background shift
        */


    // TODO leave this functionality only for Single Hero
    $('.js-hero').each(function () {
        var $this = $(this);
        var $background = $this.find('.hero__background');
        var $imageParent = $background.find('figure');
        var $image = $imageParent.find('img');
        var $imageTablet = $image.data('tablet');
        var $imageMobile = $image.data('mobile');
        var paralax = $this.attr('data-parallax');

        // if($imageParent.length > 0) {
        //     $image.remove();
        //     $imageParent.css('background-image', `url('${$image.attr('src')}')`);
        //     if(is_tablet() && $imageTablet != ''){
        //         $imageParent.css('background-image', `url('${$imageTablet}')`);
        //     }
        //     if(is_mobile() && $imageTablet != '' ){
        //         $imageParent.css('background-image', `url('${$imageMobile}')`);
        //     }
        // }

        if(paralax === '1') {
            $win.on('load scroll', function () {
                var scrollTop = $win.scrollTop();
                var offsetTop = $background.parent().offset().top;
                $imageParent.css('transform', `translate3d(0px, ${scrollTop - offsetTop}px, 0px)`);
            });
        }
    });

    //TODO: Replicate aboves behaviour on Slider


    /*
        Animate on scroll
        */

    AOS.init({
        duration: 900,
        offset: 200,
        delay: 100,
        once: true,
    });

    $win.on('load', function () {
        AOS.refresh();
    });

    function efr_maybe_get_accordion_bodies( ids ) {
        $.ajax({
            type: 'GET',
            url: main_theme.restURL + '8i/v1/getAllLockedAccordions',
            beforeSend: function (xhr) {
                xhr.setRequestHeader( 'X-WP-Nonce', main_theme.restNonce );
            },
            data: {
                'ids': ids,
            },
            success: function (response) {
                // console.log( response );

                // Replace all locked accordion row bodies with unlocked versions.
                $.each(response.data, function( id, data ) {
                    let $accordion_row  = $( '.accordion__section.is-locked[data-id="' + id + '"]' );
                    let $accordion_body = $accordion_row.find('.accordion__body');

                    if ( data === '' ) {
                        let inline_modals = $accordion_body.find('.modal--inline');

                        if ( inline_modals.length ) {
                            let group_id = inline_modals.eq(0).data('inline-modal-group')

                            efr_switch_inline_modal( group_id, 'no_access' );
                        }

                        return;
                    }

                    if ( $accordion_row.hasClass('is-case-study') ) {
                        if ( $accordion_row.hasClass('is-active') ) {
                            // console.log('redirect to: ' + data);
                            window.location.href = data;
                        } else {
                            $accordion_row.find('a').attr('href', data);
                        }
                    } else {
                        $accordion_body.html( data );
                    }

                    $accordion_row.removeClass('is-locked');
                });
            },
            error: function (response) {
                console.log(response.responseJSON);

            }
        });
    }

    let login_form_id = efront_forms.login_accordion_form_id ?? null;

    if ( login_form_id !== null ) {
        $doc.one('gform_confirmation_loaded.accordion_form', (e, form_id) => {
            if ( form_id === login_form_id ) {
                let locked_ids       = [];
                let $locked_acc_rows = $( '.accordion__section.is-locked' );

                if ( $locked_acc_rows.length ) {
                    $locked_acc_rows.each(function() {
                        locked_ids.push( $(this).data('id') );
                    });
                }

                if ( locked_ids.length ) {
                    efr_maybe_get_accordion_bodies( locked_ids );
                }
            }
        });
    }

    /*
        Accordion
        */

    $('.js-accordion').each(function (e) {
        var $this = $(this);
        var $accordionBody = $this.find('.accordion__body');


        $accordionBody.hide();

        $this.find('.accordion__head a').on('click', function (e) {
            let $accordion_head = $(this).closest('.accordion__head');
            let $accordion_body = $accordion_head.next();
            let $accordion_section = $accordion_body.closest('.accordion__section');

            if ( ! $accordion_section.hasClass('is-case-study') ) {
                // If the accordion row is not for a case study.
                e.preventDefault();
            } else if ( $accordion_section.hasClass('is-case-study') && $accordion_section.hasClass('is-locked') ) {
                // If the accordion row is for a locked case study.
                e.preventDefault();
            } else {
                // If the accordion row is for a case study and is NOT locked.
                return true; // Allow redirect to happen.
            }

            let id   = $(this).data('id');
            let type = $(this).data('type');

            let is_visible = $accordion_body.is(':visible');

            if ( is_visible ) {
                $accordion_body.slideUp(function() {
                    // Remove any injected gforms. Not strictly necessary but probably better not to have hidden gforms.
                    efr_maybe_inject_form( $accordion_body, false );
                });

                $accordion_section.removeClass('is-active');
            } else {
                efr_maybe_inject_form( $accordion_body );

                $accordion_body.slideDown();
                $accordion_section.addClass('is-active');
            }

            if ( ! $this.hasClass('js-accordion-multiple') ) {
                $accordion_section.siblings().removeClass('is-active').find('.accordion__body').slideUp();
            }            
        });

        $doc.on('click', function (e) {
            var $target = $(e.target);
            var $targetParent = $target.closest('.js-accordion');

            if(!$targetParent.length || $target.hasClass('js-accordion')) {
                $this.find('.accordion__section').removeClass('is-active').find('.accordion__body').slideUp();

            }
        })
    });

    $('.js-accordion-image-split').each(function () {
        var $this = $(this);
        var $accordionImageParent = $this.find('.accordion__image');

        $accordionImageParent.each(function () {
            var $this = $(this);
            var $accordionImage = $this.find('img');
            var $accordionImageCover = $this.find('.accordion__image-cover');

            function setCurrentImage(index, leave = false) {
                if(leave) {
                    $accordionImage.eq(index).css('z-index', 0);
                    return;
                }

                $accordionImage.eq(index).css('z-index', 1).siblings('img').css('z-index', 0);
            }

            for(var i = 0; i < $accordionImage.length; i++) {
                var partition = $('<a href="#"></a>');

                $accordionImageCover.append(partition);
            }

            $accordionImageCover.find('a').each(function () {
                var $this = $(this);
                var index = $this.index();

                $this.on('click', function (e) {
                    e.preventDefault();
                });

                $this.on('mouseenter', function () {
                    setCurrentImage(index, false);
                });

                $this.on('mouseleave', function () {
                    setCurrentImage($(this).index(), true);
                });
            });
        });
    });

    /*
        Accordion Alt
    */

    $('.js-accordion-alt ').each(function () {
        var $this = $(this);
        var $accordionBody = $this.find('.accordion__body');
        var $accordionBodyAlt = $(this).find('.accordion__body-alt');

        $accordionBody.hide();

        $this.find('.accordion__toggle').on('click', function (e) {
            e.preventDefault();

            let is_active = $this.hasClass('is-active');

            $this.toggleClass('is-active', ! is_active);
            $(this).attr('aria-expanded', is_active ? 'false' : 'true');

            if ( is_active ) {
                $accordionBody.slideUp();
            } else {
                $accordionBody.slideDown();
            }
        });
    });

    /*
        About Accordion
    */

    $('.js-accordion-about').each(function() {
        let $this     = $(this);
        let $rows     = $this.find('.accordion__section');
        let $bodies   = $this.find('.accordion__body');
        let $triggers = $this.find('.js-accordion-trigger');

        $triggers.on( 'click', ({target}) => {
            let $this_row  = $(target).closest('.accordion__section');
            let $this_trig = $(target).closest('.js-accordion-trigger');
            let $this_body = $this_row.find('.accordion__body');
            let is_open    = $this_row.hasClass('is-active');

            $rows.removeClass('is-active');
            $triggers.attr('aria-expanded', 'false');
            $bodies.stop().slideUp();

            if ( ! is_open ) {
                $this_row.addClass('is-active');
                $this_trig.attr('aria-expanded', 'true');
                $this_body.stop().slideDown();
            }
        });
    });

    /*
        About Img Change
    */
    $('.js-about').each(function () {
        let $this         = $(this);
        let $acc_triggers = $this.find('.js-accordion-trigger');

        $acc_triggers.on('click', ({target}) => {
            let $section = $(target).closest('.accordion__section')
            let index    = $section.index();
            let is_open  = $section.hasClass('is-active');

            toggleAboutImage( $this, is_open ? index : false );
        });

        $this.on('mouseenter', '.accordion__section:not(.is-active)', ({target}) => {
            let index = $(target).closest('.accordion__section').index();

            toggleAboutImage( $this, index );
        });

        $this.on('mouseleave', '.accordion__section:not(.is-active)', ({target}) => {
            let $active_row = $this.find('.accordion__section.is-active');

            if ( $active_row.length ) {
                let index = $active_row.index();

                toggleAboutImage( $this, index );
            } else {
                toggleAboutImage( $this, false );
            }
        });
    });

    function toggleAboutImage( $js_about, i ) {
        if ( i !== false ) {
            $js_about
                .find('.about__image img')
                .removeClass('is-visible')
                .filter('.about__image--people')
                .eq( i )
                .addClass('is-visible');
        } else {
            $js_about
                .find('.about__image img')
                .removeClass('is-visible')
                .filter('.about__image--default')
                .addClass('is-visible');
        }
    }


    /*
        Header Menu Delay
        */

    $header.find('.nav li, .list-contacts li').each(function (index) {
        $(this).css('transition-delay', `.${index + 1}s`);
    });

    /*
        Modal Delay
        */

    $('.modal').each(function () {
        $(this).find('.modal_animate').each(function (index) {
            $(this).css('animation-delay', `.${index}s`);
        });
    });

    /*
        Nav Trigger
        */

    $('.js-nav-trigger').on('click', function (e) {
        e.preventDefault();

        efr_toggle_nav();
    });

    /**
     * Open/close/toggle the main nav menu.
     *
     * @param {bool} open_or_close (Optional) Whether to force open or close the nav. Default = undefined (toggle).
     */
    function efr_toggle_nav( open_or_close ) {
        let is_active = $header.hasClass('is-active');

        if ( open_or_close !== undefined ) {
            is_active = ! open_or_close;
        }

        if ( is_active ) {
            $header.find('.header__menu').stop().fadeOut(300);
        } else {
            $header.removeClass('is-hidden');
            $header.find('.header__menu').stop().css('display', 'flex').hide().fadeIn(300);
        }

        $header.toggleClass('is-active', ! is_active);
        $body.toggleClass('no-scroll', ! is_active);
    }

    /*
        Modal Trigger
        */
    $body.on('click', '.js-modal-trigger',function (e) {
		e.preventDefault();

        let $this    = $(this);
        let targetId = $this.is('button') ? $(this).attr('data-target') : $(this).attr('href');
        let $target  = $(targetId);

        if ( ! $target.length ) {
            return false;
        }

		efr_open_popup( targetId );
    });

    /**
     * Modal Inline Toggle
     */
    $body.on('click', '.js-modal-inline-toggle',function (e) {
		e.preventDefault();

        let $this    = $(this);
        let group_id = $this.data('group');
        let modal_id = $this.data('modal-id');

        efr_switch_inline_modal( group_id, modal_id );
    });

    function efr_switch_inline_modal( group_id, modal_id ) {
        let $group_targets = $( '[data-inline-modal-group="' + group_id + '"]' );
        let $target        = $group_targets.filter( '[data-inline-modal-id="' + modal_id + '"]' );

        if ( ! $target.length ) {
            return false;
        }

        $group_targets.removeClass('modal-is-open');
        setTimeout(function() {
            efr_maybe_inject_form( $group_targets.not($target), false );
        }, 150);

        efr_maybe_inject_form( $target );
        $target.addClass('modal-is-open');
    }

	/**
	 * Open popup via ID.
	 *
	 * @param {string} popup_id The ID of the popup to open (with or without #).
	 */
    function efr_open_popup( popup_id ) {
        popup_id = popup_id.startsWith( '#' ) ? popup_id : '#' + popup_id;

        $.magnificPopup.open({
            items: {
                src: popup_id
            },
            mainClass   : 'mfp-fade',
            removalDelay: 300,
            showCloseBtn: false,
            type        : 'inline',
            fixedContentPos: true,
            callbacks   : {
                beforeOpen: function() {
                    // Close nav if it is open.
                    efr_toggle_nav( false );
                },
                open: function() {
                    // Add open class to mfp wrap after popup has faded in (150ms CSS transition).
                    setTimeout(() => {
                        this.wrap.addClass('modal-is-open');
                    }, 150);
                },
                elementParse: function(item) {
                    // Inject form into opened popup if it has an injection element.
                    efr_maybe_inject_form( $( item.src ) );
                },
                afterClose: function() {
                    // Remove forms from all modals.
                    // Required because afterClose only fires for the last modal.
                    // Which is an issue when switching between enquire/login modals.
                    efr_maybe_inject_form( $( '.modal' ), false );
                },
            },
        });
    }

    /**
	 * Close currently open popup.
	 */
     function efr_close_popup() {
        $.magnificPopup.close();
     }

	/**
	 * Open popup via ID from GET variable (?popup=login).
	 */
    $win.on('load', function() {
        let popup_slug = get_url_param( 'popup' );

        if ( popup_slug !== null && $( '.modal#' + popup_slug ).length ) {
            efr_open_popup( '#' + popup_slug );
        }
    });

	/**
	 * Open accordion via URL hash value.
	 */
    $win.on('load', function() {
        let hash           = window.location.hash.replace(/^#/, "");
        let accordion_item = $('.accordion .projects__row > a[data-href="' + hash + '"]');

        if ( accordion_item.length ) {
            setTimeout(function() {
                $('html, body').animate({
                    'scrollTop': accordion_item.eq(0).offset().top - ( $('header').outerHeight() + 40 ),
                }, 1000).promise().done(function(){
                    accordion_item.eq(0).trigger('click');
                });
            },200);
        }
    });

	/**
	 * Get URL param value by key.
	 *
	 * @param {string} key The key to grab the value for.
	 *
	 * @returns {string|null} URL param value or null if param doesn't exist.
	 */
	function get_url_param( key ) {
		const parsedUrl = new URL( window.location.href );

		return parsedUrl.searchParams.get( key );
	}

    /**
     * Search and inject/remove the gforms within the found injection elements.
     *
     * @param {object} $container The jQuery to search for form injection elements.
     * @param {bool} $inject_or_remove Whether to inject ot remove the forms.
     */
    function efr_maybe_inject_form( $container, $inject_or_remove = true ) {
        // Check that the form var exists.
        if ( typeof efront_forms === undefined || ! Object.keys( efront_forms ).length ) {
            return false;
        }

        let $inject_els = $container.find( '.js-form-inject' );

        $inject_els.each(function(){
            let $this        = $(this);
            let form_slug    = $this.data('form-slug');
            let current_html = $this.html();

            if ( form_slug.length && efront_forms[ form_slug ] !== undefined ) {
				let form_id  = efront_forms[ form_slug + '_form_id' ];
                let new_html = $inject_or_remove ? efront_forms[ form_slug ] : '';

                // Bail if the form has already been added.
                if ( $this.find('.gform_wrapper').length && new_html !== '' ) {
                    return;
                }

                // Bail if the form has already been removed.
                if ( current_html === '' && new_html === '' ) {
                    return;
                }

                // Get other form inject elements for this form slug.
                $other_inject_els = $( '.js-form-inject[data-form-slug="' + form_slug + '"]' ).not( $this );

                // Clear other instances of this form.
                $other_inject_els.each(function() {
                    $(this).html( '' );
                });

                // Inject or clear form.
                $this.html( new_html );

                if ( new_html !== '' ) {
                    // Trigger post_render so that gforms initialises any forms which have been added to the page.
                    $doc.trigger('gform_post_render', [form_id, 1, 'manual']);
                }
            }
        });

    }

    /*
        Cursor
        */

    var throttlePause;

    function throttleCursor(callback, time, event) {
        if (throttlePause) return;

        throttlePause = true;

        setTimeout(() => {
            callback(event);

            throttlePause = false;
        }, time);
    }

    var $cursor = $('.js-cursor');

    var $hoverElements = $('input, textarea, button, a, canvas');

    var hoverColors = [
        '#f9f9f9',
        '#fff',
        'rgb(249, 249, 249)',
        'rgb(246, 248, 246)',
        'rgb(255, 255, 255)',
    ];

    function controlCursor(e) {
        var scrollTop = $win.scrollTop();
        let $target   = $(e.target);

        $cursor.css('transform', 'translate3d('+e.clientX+'px, '+e.clientY+'px, 0)');

        if(hoverColors.includes($target.css('background-color'))) {
            $cursor.addClass('hover-white');
        } else {
            $cursor.removeClass('hover-white');
        }

        if($target.closest($hoverElements).length) {
            $cursor.addClass('is-active');
        } else {
            $cursor.removeClass('is-active');
        }
    }

    $doc.on('mousemove', function (e) {
        throttleCursor(controlCursor, 5, e);
    });

    /*
        Media
        */

    $('.js-media').each(function () {
            var $this = $(this);

            $win.on('load resize orientationchange', function () {
                $this.css('--media-height', `${$this.outerHeight()}px`);
                $this.css('--media-width', `${$this.outerWidth()}px`);
            });
    });

    /*
        Video
        */

    $('.js-video').each(function () {
        var $this = $(this);

        $win.on('load resize', function () {
            var width = $this.outerWidth();
            var height = $this.outerHeight();

            var ratioWidth = height * 1.7777;
            var ratioHeight = width * 0.5625;

            if ( width > height && width > ratioWidth) {
                $this.css('--video-width', `${width}px`);
                $this.css('--video-height', `${ratioHeight}px`);
                $this.css('--video-controls-bottom', `${(ratioHeight - height) / 2}px`);
            }

            if ( width > height && width < ratioWidth ) {
                $this.css('--video-width', `${ratioWidth}px`);
                $this.css('--video-height', `${height}px`);
                $this.css('--video-controls-bottom', `0px`);
            }

            if ( width < height ) {
                $this.css('--video-width', `${ratioWidth}px`);
                $this.css('--video-height', `${height}px`);
                $this.css('--video-controls-bottom', `0px`);
            }
        });
    });

    let players = [];

    function toggleVideo( targetId ) {
        let $target   = $( targetId );
        let player_id = $target.data('player-id');
        let player    = players[ player_id ];

        if ( player.playing ) {
            player.pause();
        } else {
            player.play();
        }
    }

    $('.js-video-trigger').on('click', function (e) {
        e.preventDefault();

        let targetId = $(this).attr('href');

        toggleVideo( targetId );
    });

    $('.js-video').each(function (i) {
        let $this   = $(this);
        let $player = $this.find('.video__player');
        let config  = $player.data('plyr-config');

        let player = new Plyr(
            $player.get(0),
            config
        );

        players.push( player );

        $this.attr('data-player-id', i);
    });

    /*
        Line Observer
        */

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {

            if(entry.isIntersecting) {
                $(entry.target).addClass('line--animate');
            }
        });
    });

    $('.js-line').each(function () {
        observer.observe(this);
    });

    /*
        Dots
    */

    function Circle (x, y, xBox, yBox, width, height, rad, color = '#39B54A') {
        this.x = x;
        this.y = y;
        this.velocityX = 5;
        this.velocityY = 5;
        this.currentX = x;
        this.currentY = y;
        this.xBox = xBox;
        this.yBox = yBox;
        this.hoverCoords = { top: yBox, left: xBox, bottom: yBox + height, right: xBox + width};
        this.width = width;
        this.height = height;
        this.rad = rad;
        this.currentRad = rad;
        this.color = color;
    }

    function CanvasGrid (grid, ctx, dotsSizes, width, height, mouseX, mouseY, cursorRad) {
        this.grid = grid;
        this.ctx = ctx;
        this.dotsSizes = dotsSizes;
        // this.dotsSizesMobile =  dotsSizesMobile || dotsSizes;
        this.width = width;
        this.height = height;
        this.mouseX = mouseX;
        this.mouseY = mouseY;
        this.cursorRad = cursorRad;
        this.cursorHover = {
            top: (mouseY - cursorRad),
            left: (mouseX - cursorRad),
            right: (mouseX + cursorRad),
            bottom: (mouseY + cursorRad),
        };
        this.circles = [];
        this.hoveredCircles = [];

        this.setCursorPosition = function (x , y) {
            this.mouseX = x;
            this.mouseY = y;
            this.cursorHover = {
                top: (y - this.cursorRad),
                left: (x - this.cursorRad),
                right: (x + this.cursorRad),
                bottom: (y + this.cursorRad),
            }
        }

        this.generateCircles = function () {
            var counter = 0;
            var rowCount = 0;
            var width = this.width;
            var height = this.height;
            var grid = this.grid;
            var circles = [];

            this.dotsSizes.forEach(function (dot, index) {
                counter = Math.ceil(index % grid); //repeating column number - resetting on every dotsGrid-th item - 3 in this case

                var canvasCell = {
                    width: width / grid,
                    height: height / grid,
                    x: 0,
                    y: 0,
                };

                canvasCell.x = counter * canvasCell.height;
                canvasCell.y = rowCount * canvasCell.width;

                var circle = new Circle(canvasCell.x + canvasCell.width / 2, canvasCell.y + canvasCell.height/2, canvasCell.x, canvasCell.y, canvasCell.width, canvasCell.height, parseInt(dot));

                circles.push(circle);

                if(counter === grid - 1) {
                    rowCount++; //increment after every dotsGrid-th item - 3 in this case
                }
            });

            this.circles = circles;
        };

        this.getHoveredCircles = function () {
            var cursorHover = this.cursorHover;

            this.hoveredCircles = this.circles.filter(function (circle) {
                //check if cursor is intersecting with dots hover radius
                if(circle.hoverCoords.left >= cursorHover.right ||
                    circle.hoverCoords.top >= cursorHover.bottom ||
                    circle.hoverCoords.right <= cursorHover.left ||
                    circle.hoverCoords.bottom <= cursorHover.top) {
                    return;
                } else {
                    return circle;
                }
            });
        };

        this.draw = function() {
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);  //clear canvas before draw
            this.circles.forEach(function (circle, index) {
                var rad = circle.currentRad;

                ctx.beginPath();
                ctx.fillStyle = circle.color;
                ctx.arc(circle.currentX, circle.currentY, rad, 0, Math.PI * 2);
                ctx.fill();
                ctx.closePath();
            });
        };

        this.update = function () {
            var circles = this.circles;
            var mouseX = this.mouseX;
            var mouseY = this.mouseY;
            var hoveredCircles = this.hoveredCircles;
            this.cursorRad = Math.ceil($cursor.width()/2);
            var cursorRad = this.cursorRad;

            this.circles.forEach(function (circle, index) {
                var circleX = circle.currentX;
                var circleY = circle.currentY;
                var circleRad = circle.currentRad;

                var circleCenterX = circle.x;
                var circleCenterY = circle.y;
                var circleDefaultRad = circle.rad;

                if (!hoveredCircles.includes(circle)) { //revert circle to original if unhovered
                    circle.currentX += (circleCenterX - circleX) / circle.velocityX;
                    circle.currentY += (circleCenterY - circleY) / circle.velocityY;

                    if(circleRad > 0) {
                        circle.currentRad += (circleDefaultRad - circleRad) / circle.velocityX;
                    }
                }

                if(hoveredCircles.includes(circle)) { //updater circle coord if circle is hovered
                    circle.currentX += (mouseX - circleX) / circle.velocityX;
                    circle.currentY += (mouseY - circleY) / circle.velocityY;

                    if(circleRad > 0) {
                        circle.currentRad += (cursorRad - circleRad) / circle.velocityX;
                    }
                }

            });

            this.draw();
        };
    }

    $('.js-dot canvas').each(function () {
        var $canvas = $(this).get(0);
        var dotsGrid = parseInt(($($canvas).data('dots-grid')));
        var ctx = $canvas.getContext('2d');
        var dotsSizes = $($canvas).data('dots-rad').split(',');
        // var dotsSizesMobile = $($canvas)?.data('dots-rad-mobile')?.split(',');
        var canvasWidth = $($canvas).width();
        var canvasHeight = $($canvas).height();
        var mouseX = 0;
        var mouseY = 0;
        var scale = window.devicePixelRatio // scale for retina displays
        var cursorRad = Math.ceil($cursor.width() / 2);



        //set dimentions of canvas to prevent stretching
        function resizeCanvas($canvas, ctx, width, height, scale) {
            $canvas.width = width * scale;
            $canvas.height = height * scale;
            ctx.scale(scale, scale);
        }

        resizeCanvas($canvas, ctx, canvasWidth, canvasHeight, scale);

        $win.on('resize', function () {
            resizeCanvas($canvas, ctx, canvasWidth, canvasHeight, scale);
        });

        var canvasGrid = new CanvasGrid(dotsGrid, ctx, dotsSizes, canvasWidth, canvasHeight, mouseX, mouseY, cursorRad);//grid, ctx, dotsSizes, width, height, mouseX, mouseY, cursorRad
        canvasGrid.generateCircles();
        canvasGrid.draw();

        setInterval(function () {
            canvasGrid.update();
        }, 33);

        function handleCirclePosition (event) {
            mouseX = event.offsetX || event.pageX - $(event.target).offset().left;
            mouseY = event.offsetY || event.pageY - $(event.target).offset().top;
            canvasGrid.setCursorPosition(mouseX, mouseY);
            canvasGrid.getHoveredCircles();
        }

        var throttleCanvas;

        function throttle(callback, time, event) {
            if (throttleCanvas) return;

            throttleCanvas = true;

            setTimeout(() => {
                callback(event);

                throttleCanvas = false;
            }, time);
        }

        $($canvas).on('mousemove', function (event) {

            throttle(handleCirclePosition, 33, event);
        });

        $($canvas).on('mouseleave', function (event) {
            setTimeout(function (argument) {
                canvasGrid.hoveredCircles = [];
            }, 33); // reset circle on mouse leave
        });
    });


})(jQuery, window, document);